export const LEGAL_ENTITIES = [
    'ООО "АЛТ"',
    'ООО "ЛидерХ"',
    'ООО "ТИМЕР ТРАНС"',
    'ООО "ТимерЛэнд"',
];

export function localToday() {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60_000;
    return new Date(now.getTime() - offset).toISOString().slice(0, 10);
}
